import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useStore } from "../../../contexts/StoreProvider";
import {
  getLoggedInTenantIdFromLocalStorage,
} from "../../../helpers/local-stotrage-helper";
import { IAddFotaHostConfig } from "../../../models/response/IFotaNewResponse";
import { formatMessage } from "../../../translations/format-message";
import AddEditFotaTenantForm from "../forms/add-edit-fota-tenant-form";

interface IProps {
  id: number;
  modalClosed: () => void;
}

const AddEditFotaTenant = (props: IProps) => {
  const { fotaTntReleaseStore, groupStore } = useStore();
  const {
    addUpdateFotaState,
    inProgress,
    resetFotaHostConfigState,
    getFotaHostConfigDetail,
    UpdateFotaHostConfigService,
    AddFotaHostConfigService,
    GetFotaHostConfigByIdService,
    fotaHostConfigDetailState,
  } = fotaTntReleaseStore;
  const { GetAllGroupService, allAllGroupOptions } = groupStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    GetAllGroupService(getLoggedInTenantIdFromLocalStorage());
    if (props.id > 0) GetFotaHostConfigByIdService(props.id);
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateUserSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFotaState.success) {
      if (props.id > 0)
        toast.success(formatMessage("updated_success"));
      else
        toast.success(formatMessage("added_success"));
      onModalClosed();
    }
  }, [addUpdateFotaState.success]);

  const handleSubmitTenantAdmin = (data: IAddFotaHostConfig) => {
    let tempWantToUpdateFile = data.WantToUpdateFile === "true" ? true : false;
    const payload: any = {
      ConfigName: data.ConfigName,
      Version: data.Version,
      FileInString: data.File,
      FileType:
        typeof data.FileType === "string"
          ? parseInt(data.FileType)
          : data.FileType,
      Description: data.Description.trim(),
      FileName: data.FileName?.trim(),
    };
    if (props.id > 0) UpdateFotaHostConfigService({
      ...payload,
      WantToUpdateFile: tempWantToUpdateFile,
      FileInString: tempWantToUpdateFile ? data.File : "",
      FileName: tempWantToUpdateFile ? data.FileName : "",
    }, props.id);
    else AddFotaHostConfigService({ ...payload });
  };

  /**
   * This function closes the pop up modal and reset getuserdetails, addUpdate user observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetFotaHostConfigState();
    props.modalClosed();
  };

  return (
    <AddEditFotaTenantForm
      initialValues={getFotaHostConfigDetail}
      id={props.id}
      groupOptions={allAllGroupOptions}
      submitHandler={handleSubmitTenantAdmin}
      onModalClosed={onModalClosed}
      dataLoading={fotaHostConfigDetailState.inProgress || inProgress}
      actionLoading={addUpdateFotaState.inProgress}
    />
  );
};

export default observer(AddEditFotaTenant);
